import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogicConfigUpgradeSection = () => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-enable-logic-properties');
  return /*#__PURE__*/_jsx(Tile, {
    compact: true,
    marginBlockEnd: "200",
    children: /*#__PURE__*/_jsx(TileSection, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'editor.logic.upgradeTitle'
            })
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'editor.logic.upgradeMessage'
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          size: "small",
          onClick: openUpgradeModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'editor.logic.upgradeButtonText'
          })
        })]
      })
    })
  });
};
export default LogicConfigUpgradeSection;